/**
 * Central export for canvas components
 */

// Export all canvas components
export { BaseCanvas } from './BaseCanvas'
export { ConceptCanvas } from './ConceptCanvas'

// Block-aware canvas for the block system
export { BlockAwarePlayCanvas } from './BlockAwarePlayCanvas'
export type { BlockAwarePlayCanvasProps } from './BlockAwarePlayCanvas'

// SVG-based players overlay (block architecture)
export { PlayersOverlay } from './PlayersOverlay'

// Re-export from adapter for existing importers
export { playerToPlayerBlock } from '@/adapters/PlayerAdapter'

// Export types
export type * from './BaseCanvas.types'
export type { ConceptAssignment } from './ConceptCanvas'
